<a mat-stroked-button *ngIf="editable; else notEditable" (click)="openDialog()" matTooltip="Inspekteure zuweisen">{{ content }}</a>
<ng-template #notEditable>{{ content }}</ng-template>
